<template>
  <div class="app-main-content">
    <!-- 需要在切换回来后，页面保持不变，所以使用v-show -->
    <booking-tree-grid
      v-show="view==='list'"
      ref="bookingTreeGrid"
      :context="context"
      :is-query="isQuery"
      :integrated-logistics-type="logisticsType"
      @look="lookHandle"
      @add="addHandle"
      @edit="editHandle"
      @split="splitHandle"
      @copy="copyHandle"
    />
    <booking-workspace
      v-show="view==='detail'"
      ref="bookingWorkspace"
      :parent-context="context"
      :view="view"
      :integrated-logistics-type="logisticsType"
      @copy="copyHandle"
      @back="backToList"
      @add="addHandle"
    />
    <!--业务复制选择复制哪些信息-->
    <job-copy-window
      :visible.sync="copyDialog.visible"
      :lob="copyDialog.job.lob || ''"
      :container-load-type="copyDialog.job.containerLoadType || ''"
      @confirmCallBack="confirmCallBackHandler"
    />

    <!-- 业务类型选择 -->
    <el-dialog
      v-if="orderTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="orderTypeDialog.visible"
      :title="$t('CargoMsg.Cargo_OrderType')"
      :width="$selectByLang('400px', '640px')"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="orderTypeDialog.visible=false"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <el-radio-group v-model="orderTypeDialog.containerLoadType">
          <el-radio v-if="!orderTypeDialog.masterFlag" no="orderType0" label="TT">{{ $t('CargoMsg.Cargo_TruckTrailer') }}</el-radio>
          <el-radio v-if="!orderTypeDialog.masterFlag" no="orderType1" label="CL" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_WholeVehicleAndLessThanCarload') }}</el-radio>
          <el-radio v-if="!orderTypeDialog.masterFlag" no="orderType2" label="IC" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_IC') }}</el-radio>
          <el-radio v-if="orderTypeDialog.masterFlag" no="orderType3" label="IC" style="margin-left: 80px;">{{ $t('CargoMsg.Cargo_IC_Master') }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button no="Confirm" type="primary" @click="confirmJobLovHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="Cancel" @click="() =>{this.orderTypeDialog.visible=false}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { IeBookingContext } from './ieBookingContext'
import bookingTreeGrid from './components/booking/bookingTreeGrid.vue'
import bookingWorkspace from './components/booking/bookingWorkspace'
import jobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import { ErrorTip } from '@/utils/class/ErrorTip'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { doCopyJob, advancedQuery } from '@/api/integratedJob/ieBooking'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JumpUtil } from '@/utils/JumpUtil'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'

export default {
  name: 'IEBooking',
  components: { bookingTreeGrid, bookingWorkspace, jobCopyWindow },
  data() {
    return {
      loading: null,
      context: new IeBookingContext(),
      view: 'list',
      copyDialog: {
        visible: false,
        job: {}
      },
      orderTypeDialog: {
        visible: false,
        containerLoadType: 'TT', // TT 集卡拖车 或 CL 整车/零担 或 IC 国际卡航
        masterFlag: false, // 是否主票
        row: null
      },
      isQuery: false // 根据路由参数进行高级查询
    }
  },
  computed: {
    logisticsType() {
      return this.integratedLogisticsType || ''
    }
  },
  activated() {
    const params = this.$route.params
    if (params.conditions) {
      this.isQuery = true
      this.view = 'list'
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(params.conditions)
      delete params.conditions
    } else if (this.$route.params.jobNos) {
      JumpUtil.jumpToTab(advancedQuery, {}, this.$route.params, this)
    } else if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo, this.$route.params.branchId)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    } else if (this.$route.params.code) {
      if (this.$route.meta.showExtraParam) {
        this.view = 'list'
        this.$route.meta.showExtraParam = false
      }
      this.isQuery = true
      this.sopNodeAdvancedQuery()
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    // 首页sop面板高级查询
    sopNodeAdvancedQuery() {
      const { code, subCode, name, subName, newSubNodes, etdStart, templateKey } = this.$route.params
      let jobState = this.$route.params.jobState
      jobState = jobState.split(',').map(item => { return Number(item) })
      const data = [
        {
          fieldName: 'trackingInfo._multipleState_',
          fieldType: 'trackingMultiple',
          operator: '=',
          value: {
            operator: 'and',
            value: [
              {
                code,
                name,
                details: []
              }
            ]
          }
        },
        {
          fieldName: 'job.ETD',
          fieldType: 'FIELD_DATE_RANGE',
          operator: 'RANGE',
          value: `type=date,start=${etdStart}`
        },
        {
          fieldName: 'job.JOB_STATE',
          fieldType: null,
          label: '',
          operator: 'IN',
          value: jobState
        }
      ]
      if (subCode && subName) {
        data[0].value.value[0]['details'].push({ code: subCode, name: subName })
      } else {
        data[0].value.value[0]['details'] = newSubNodes
      }
      // Sop模板UUID
      if (templateKey) {
        data.push(
          {
            fieldName: 'job.TRACKING_TEMPLATE_UUID',
            fieldType: null,
            label: '',
            operator: '=',
            value: templateKey
          }
        )
      }
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(data)
    },
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    async addHandle(row) {
      await this.context.prepareData()
      if (!this.context.office) {
        this.$message.info(this.$t('Message.CurrentBranchIsNotSelectedCannotAddNewBookings'))
        return
      }
      if (JobUtils.checkHQ()) { return }
      // CARGO-49237 如果路由参数中包含TT、CL、IC，则直接跳转到对应页面 不需要选择
      this.orderTypeDialog.row = new IntegratedJob().fillDefaultValue().getData()
      this.orderTypeDialog.containerLoadType = 'TT'
      this.orderTypeDialog.masterFlag = false
      if (row && row.masterFlag) {
        this.orderTypeDialog.row.masterFlag = row.masterFlag
        if (this.logisticsType && this.logisticsType === ContainerLoadType.STUFFY_IC.code) {
          this.orderTypeDialog.row.containerLoadType = this.logisticsType
          this.detailHandle('add', this.orderTypeDialog.row)
          return
        }
        this.orderTypeDialog.containerLoadType = ContainerLoadType.STUFFY_IC.code
        this.orderTypeDialog.masterFlag = row.masterFlag
        this.orderTypeDialog.visible = true
        return
      }
      if (this.logisticsType) {
        this.orderTypeDialog.row.containerLoadType = this.logisticsType
        this.detailHandle('add', this.orderTypeDialog.row)
      } else {
        this.orderTypeDialog.containerLoadType = 'TT'
        this.orderTypeDialog.visible = true
      }
    },
    async editHandle(row) {
      if (row.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new RailwayExportJob(row))) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.detailHandle('edit', row)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    copyHandle(row) {
      // 以后按本次选择复制，不弹出此框
      if (!row) return
      if (JobUtils.checkHQ()) { return }
      this.copyDialog.job = row
      const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob) // 是否显示复制选项弹框【勾选是true不显示】
      this.$logger.log('是否显示复制选项弹框', typeof isShowView + isShowView)
      if (isShowView !== true) {
        this.copyDialog.visible = true
      } else {
        this.confirmCallBackHandler()
      }
    },
    async confirmCallBackHandler() {
      this.doCopyJob()
    },
    doCopyJob() {
      const item = {}
      item.jobRule = ''
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.copyDialog.job.lob
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
      item.truckingInfo = LocalStorageUtils.getConfiguration('COPY_TRUCK_INFO_' + lob)
      item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob)
      const notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob)
      item.all = false
      this.loading = getLoading()
      doCopyJob(item).then(async res => {
        this.loading.close()
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice
        newJob.planner = 0
        newJob.soNo = ''
        newJob.bookingNo = ''
        newJob.returnPeriodBegin = ''
        newJob.returnPeriodEnd = ''
        newJob.fileCutoff = ''
        const continueExec = await JobUtils.validateCompanyActive(newJob, this, 'IEBooking')
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect, { delay: true })
        this.detailHandle('copy', newJob)
      })
    },
    // 查询job后跳转详情
    toDetail(vm, jobNo, branchId) {
      const filter = {}
      filter.conditions = [
        new AdvancedSearchOption(null, 'job.JOB_NO', jobNo, 'LIKE').formatObj2Json()
      ]
      filter.branchId = branchId || this.$store.getters.currentOfficeId
      filter.pageNum = 1
      filter.pageSize = this.pageSize
      vm.view = 'detail'
      advancedQuery(filter).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length > 0) {
          vm.$refs.bookingWorkspace.saveJobNos = []
          vm.$refs.bookingWorkspace.removedJobNos = []
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(vm.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    },
    // 进详情处理
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.bookingWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.bookingTreeGrid.rowData
      }
      this.$refs.bookingWorkspace.saveJobNos = []
      this.$refs.bookingWorkspace.removedJobNos = []
      this.$refs.bookingWorkspace.onShow(type, rowData, row)
    },
    backToList(saveJobNos, removedJobNos) {
      this.view = 'list'
      if (this.$route.query.jobNo) {
        delete this.$route.query.jobNo
        delete this.$route.query.currentOfficeId
      }
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.$refs.bookingTreeGrid.toQuery(saveJobNos, removedJobNos)
      }
    },
    // 确认选择业务类型
    confirmJobLovHandler() {
      this.orderTypeDialog.visible = false
      this.orderTypeDialog.row.containerLoadType = this.orderTypeDialog.containerLoadType
      this.detailHandle('add', this.orderTypeDialog.row)
    }
  }
}
</script>
